var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 5.70997C18.41 5.31997 17.78 5.31997 17.39 5.70997L12.5 10.59L7.60997 5.69997C7.21997 5.30997 6.58997 5.30997 6.19997 5.69997C5.80997 6.08997 5.80997 6.71997 6.19997 7.10997L11.09 12L6.19997 16.89C5.80997 17.28 5.80997 17.91 6.19997 18.3C6.58997 18.69 7.21997 18.69 7.60997 18.3L12.5 13.41L17.39 18.3C17.78 18.69 18.41 18.69 18.8 18.3C19.19 17.91 19.19 17.28 18.8 16.89L13.91 12L18.8 7.10997C19.18 6.72997 19.18 6.08997 18.8 5.70997Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a709cdb5bf18d7d6afde45026c7a0c46.svg";
export { ForwardRef as ReactComponent };